import { Observable } from 'rxjs';

import { isNullOrUndefined } from '../../util/is-null-or-undefined.util';

import { RequisicaoParametroCharon } from '../charon/models/requisicao-parametro-charon.model';

/**
 * Interface de representação dos dados de configuração necessários para uma requisicao de uma operação
 * @export
 * @interface ConfiguracaoRequisicaoOperacao
 */
export class ConfiguracaoRequisicaoOperacao {
  nomeOperacao: string;
  metodo: 'GET' | 'POST' | 'DELETE' | 'PATCH' | 'PUT';
  cabecalhos: Array<RequisicaoParametroCharon>;
  parametrosRota: Array<RequisicaoParametroCharon>;
  parametrosQuery: Array<RequisicaoParametroCharon>;
  corpoOperacao: any;

  adicionarCabecalho(chave: string, valor: string) {
    if (isNullOrUndefined(this.cabecalhos)) {
      this.cabecalhos = new Array<RequisicaoParametroCharon>();
    }

    this.cabecalhos.push(new RequisicaoParametroCharon(chave, valor));
  }

  adicionarParametroQuery(chave: string, valor: string) {
    if (isNullOrUndefined(this.parametrosQuery)) {
      this.parametrosQuery = new Array<RequisicaoParametroCharon>();
    }

    this.parametrosQuery.push(new RequisicaoParametroCharon(chave, valor));
  }

  adicionarParametroRota(chave: string, valor: string) {
    if (isNullOrUndefined(this.parametrosRota)) {
      this.parametrosRota = new Array<RequisicaoParametroCharon>();
    }

    this.parametrosRota.push(new RequisicaoParametroCharon(chave, valor));
  }
}

// Modelo de método de callback, que deverá ser implementado quando há a necessidade de se tratar os dados da requisição
// para cada chamada em específico
export type ResultadoCallBack = (resultado: any) => any;
